module.exports = __webpack_public_path__ + "img/arrow-down.f6ebd348.svg";